import styled, { css } from "styled-components";
import { Colors } from "../../config";

const arrowDownCircle = require("../../assets/images/Arrow-DownCircle.png");

const NameRelationHeader = ({
  name,
  firstName,
  lastName,
  relation,
  // index,
  isAccordionOpen,
  handleClick,
}) => {
  return (
    <Wrapper>
      <NameRelationWrapper>
        <RelationWrapper>{relation}</RelationWrapper>
        {name && <NameWrapper>{name}</NameWrapper>}
        {firstName && (
          <FirstLastName>
            <NameWrapper capitalize>{firstName}</NameWrapper>
            <NameWrapper capitalize>{lastName}</NameWrapper>
          </FirstLastName>
        )}
      </NameRelationWrapper>
      <ArrowImage
        src={arrowDownCircle}
        alt="view"
        isAccordionOpen={isAccordionOpen}
        onClick={handleClick}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NameRelationWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ArrowImage = styled.img`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
    transition: transform 0.2s ease-in;
    width: 20px;
    height: 20px;
    ${(props) =>
      props.isAccordionOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

const RelationWrapper = styled.div`
  color: ${Colors.brandTwo};
  font-size: 1rem;
  font-weight: 400;

  @media only screen and (max-width: 480px) {
    font-size: 0.875rem;
  }
`;

const NameWrapper = styled.div`
  color: ${Colors.brandOne};
  font-size: 1.375rem;
  font-weight: 600;
  ${(props) =>
    props.capitalize &&
    css`
      text-transform: capitalize;
    `}
  @media only screen and (max-width: 480px) {
    font-size: 1rem;
  }
`;
const FirstLastName = styled.div`
  display: flex;
  gap: 0.5rem;
`;
export default NameRelationHeader;
